export const SHOW_HEAD = 'SHOW_HEAD';
export const SHOW_FOOTER = 'SHOW_FOOTER';
export const SHOW_WAIT_BLOCK = "SHOW_WAIT_BLOCK";
export const STEP_WAIT_BLOCK = "STEP_WAIT_BLOCK";
export const ERROR_WAIT_BLOCK = "ERROR_WAIT_BLOCK";
export const ACTIVATE_DEMO = "ACTIVATE_DEMO";


// =========================================================================
//                               STRUCTURE
// =========================================================================

// -------------------------
// GENERAL
// -------------------------

export function changeHead(llave){
	return (dispatch, getState) => {
        dispatch({type: SHOW_HEAD, payload: {showHead: llave} });
	}
}

export function changeFooter(llave){
    return (dispatch, getState) => {
        dispatch({type: SHOW_FOOTER, payload: {showFooter: llave} });
    }
}

export function showWaitBlock(activate) {
    return (dispatch, getState) => {
        dispatch({type: SHOW_WAIT_BLOCK, payload: {showWaitBlock: activate}});
    };
}

export function changeStepWaitBlock(step) {
    return (dispatch, getState) => {
        dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: step}});
    };
}

export function changeErrorWaitBlock(error) {
    return (dispatch, getState) => {
        dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: error}});
    };
}

export function setActivateDemo() {
    return (dispatch) => {
        dispatch({type: ACTIVATE_DEMO, payload: {activateDemo: true}})
    }
}
